import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useThread() {
  const [searchParams, setSearchParams] = useSearchParams();

  const threadId = searchParams.get('threadId');
  const setThreadId = useCallback(
    (newThreadId?: string | null) => {
      if (newThreadId === threadId || (!newThreadId && !threadId)) {
        return;
      }
      const nextSearchParams = new URLSearchParams(searchParams.toString());
      if (newThreadId) {
        nextSearchParams.set('threadId', newThreadId);
      } else {
        nextSearchParams.delete('threadId');
      }
      setSearchParams(nextSearchParams);
    },
    [searchParams, setSearchParams, threadId]
  );

  return {
    threadId,
    setThreadId,
  };
}
